import { useEffect } from 'react';
import StatusMessage from 'components/StatusMessage';
import useRequestMediaDeviceAccess from 'hooks/useRequestMediaDeviceAccess';
import micAccessDialog from '../../../assets/mic-access-dialog.png';
import { useAuscultation } from 'hooks/useAuscultation';

export default function RequestMicrophoneAccess() {
  const { setNextSetupStepEnabled } = useAuscultation();
  const { mediaAccessGranted, error } = useRequestMediaDeviceAccess();

  useEffect(() => {
    setNextSetupStepEnabled(!!mediaAccessGranted);
  }, [setNextSetupStepEnabled, mediaAccessGranted]);

  const getContent = () => {
    if (mediaAccessGranted === false) {
      return (
        <StatusMessage status="error">
          Åtkomst till mikrofon saknas. Ge åtkomst till mikrofonen i din webbläsares inställningar för att gå vidare.
        </StatusMessage>
      );
    }

    if (mediaAccessGranted) {
      return <StatusMessage status="success">Klart! Du kan nu gå vidare till nästa steg.</StatusMessage>;
    }

    if (error) {
      return <StatusMessage status="error">Något gick snett.</StatusMessage>;
    }

    return null;
  };

  return (
    <>
      <img
        src={micAccessDialog}
        width={322}
        height={252}
        alt="Tillgångsdialog för mikrofon"
        style={{ marginTop: '10px' }}
      />
      <div className="padded-content mt-1">
        <ol className="mt-1">
          <li>Du ska ha fått en förfrågan om att tillåta webbläsaren att spela in ljud via mikrofonen.</li>
          <li>
            <strong>OBS!</strong> Du behöver godkänna förfrågan att kunna spela in ljud. Välj alternativet som innebär
            att webbplatsen alltid har tillgång till mikrofonen.
          </li>
        </ol>
        <div className="mt-1">{getContent()}</div>
      </div>
    </>
  );
}
